import {
  FlexBox,
  Icon,
  IconNames,
  Text,
  Timestamp,
} from '@dixa/lib-shared-habla';
import classnames from 'classnames';

import { HistoricalNotification } from 'components/notifications/components/notificationsPage/notificationsPage.types';

import { ConversationStatusIcon } from '../../../conversation/components/conversationStatusIcon';

import styles from './notificationHistoryItem.module.scss';

type NotificationHistoryItemProps = {
  notification: HistoricalNotification;
  leftAction?: JSX.Element;
  rightAction?: JSX.Element;
};

const notificationTypeMap = {
  'rating-up': ['thumbs-up', 'Positive rating'],
  'rating-down': ['thumbs-down', 'Negative rating'],
} as const;

export const NotificationHistoryItem = ({
  notification,
  leftAction,
  rightAction,
}: NotificationHistoryItemProps): JSX.Element => {
  const { icon, status, title, type, conversation } = notification.presentation;

  const [ratingIcon, ratingTitle] = notificationTypeMap[type ?? ''] ?? [];

  const ConversationIcon = conversation ? (
    <ConversationStatusIcon
      channel={conversation.channel}
      direction={conversation.direction}
      status={conversation.status}
    />
  ) : null;

  const RatingIcon = ratingIcon ? <Icon name={ratingIcon} size={24} /> : null;

  const DisplayIcon =
    ConversationIcon ??
    RatingIcon ??
    (icon ? (
      <Icon name={icon.replace(/^(i-)/, '') as IconNames} size={24} />
    ) : null);

  const iconClass = classnames({
    [styles.icon]: true,
    [styles.iconSuccess]: status === 'success',
    [styles.iconWarning]: status === 'warning',
    [styles.iconDanger]: status === 'danger',
  });

  return (
    <FlexBox padding="300" flexDirection="column">
      <FlexBox>
        <FlexBox
          alignItems="center"
          justifyContent="center"
          margin="0 300 0 0"
          className={iconClass}
        >
          {DisplayIcon}
        </FlexBox>
        <FlexBox flexDirection="column">
          <Text.Paragraph variant="2" wrap="nowrap">
            {ratingTitle ?? title}
          </Text.Paragraph>
          <Text.Paragraph variant="4" color="neutral.500" subdued>
            <Timestamp time={notification.timestamp} />
          </Text.Paragraph>
        </FlexBox>
      </FlexBox>
      {(leftAction || rightAction) && (
        <FlexBox padding="300 0 0 0" justifyContent="space-between">
          {leftAction}
          {rightAction}
        </FlexBox>
      )}
    </FlexBox>
  );
};
